export default __webpack_public_path__ + "static/media/no-search-results.206bcbad.png";